import { render, staticRenderFns } from "./ContainerProductDialog.vue?vue&type=template&id=104ffe8e"
import script from "./ContainerProductDialog.vue?vue&type=script&lang=js"
export * from "./ContainerProductDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports